import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "reactstrap";
import BizinBackend from "../../../helpers/bizin_helper";
import useGetCsrfToken from "../../../Hooks/useGetCsrfToken";
import { DF_OT0015Context } from "../context";
import { Alert } from "reactstrap";
import CardContext from "../../../components/Common/CardContext";
import CardFlow from "../../../components/Common/CardFlow";
import TableSimple from "../../../components/Dynamic/TableSimple";
import { CardGridCollapseCustom } from "../../../components/Common/CardGridCustom";
import useGetHeightPage from "../../../Hooks/useGetHeightPage";

const alerts = {
  E: {
    color: "text-color-vermelho2",
    type: "danger",
  },
  A: {
    color: "text-color-amarelo2",
    type: "warning",
  },
  S: {
    color: "text-color-verde2",
    type: "success",
  },
};

function GridBody() {
  const { access_token, isModalPage, userProfile } = useSelector((state) => ({
    access_token: state.login.user.access_token,
    isModalPage: state.Layout.isModalPage,
    userProfile: state.login.profile,
  }));

  const { idAgendamento, idArquivo } = useContext(DF_OT0015Context);

  const csrfToken = useGetCsrfToken();
  useGetHeightPage();
  const [data, setData] = useState([]);
  const [flowData, setFlowData] = useState([]);

  const handleCloseModal = () => {
    if (window.top !== window.self) {
      window.parent.postMessage(
        { type: "closeModal", isReloadPage: true },
        "*",
      );
    } else {
      window.close();
    }
  };

  useEffect(() => {
    if (!csrfToken) return;
    if (!idAgendamento) return;
    if (!idArquivo) return;

    const getData = async () => {
      try {
        const [detailsResp, flowResp] = await Promise.all([
          BizinBackend.executeProcedure(
            { 1: idAgendamento },
            "FRONT_DF_OT0015_Obter_Detalhes_Agendamento",
            csrfToken,
            access_token,
          ),
          BizinBackend.executeProcedure(
            { 1: userProfile?.ID_Usuario, 2: "pt-BR", 3: idArquivo },
            "FRONT_Workspace_Obter_Documento_Fluxo_Participantes",
            csrfToken,
            access_token,
          ),
        ]);

        setData(detailsResp);

        const flowResult = Array.isArray(flowResp) ? flowResp : [];
        setFlowData(
          flowResult.map((item) => ({
            name: item.Nome_Empresa,
            description: item.Descricao,
            logo: item.Logo_Empresa,
          })),
        );
      } catch (error) {
        console.error(error);
      }
    };
    getData();
  }, [csrfToken, idAgendamento, access_token, userProfile?.ID_Usuario]);

  return (
    <div style={{ ...(!isModalPage && { height: "calc(100vh - 130px)" }) }}>
      <Row className="my-3">
        {flowData.length > 0 && (
          <Col xs={12} className="mb-3">
            <CardFlow flowData={flowData} enableTooltip={false} />
          </Col>
        )}

        <Col xs={12}>
          {Array.isArray(data?.resultset_1) && data.resultset_1.length > 0 && (
            <div className="mb-3">
              <CardContext
                data={data.resultset_1.map((row) => ({
                  label: row.Coluna,
                  value: row.Valor,
                }))}
              />
            </div>
          )}

          <div className="mb-3">
            <TableSimple
              dataKey={"ID_Agendamento"}
              data={data?.resultset_2 || []}
              enableTotalRows
              hiddenPaginator
              columnsList={[
                {
                  field: "Descricao_Completa",
                  header: "Descrição",
                },
                {
                  field: "Documento",
                  header: "Documento",
                },
                {
                  field: "Chave_Acesso",
                  header: "Chave Acesso",
                },
              ]}
            />
          </div>
        </Col>
      </Row>

      <div className="mb-3">
        <div className="title-log-cancelamento">
          <CardGridCollapseCustom opened title="Log de Cancelamento">
            <TableSimple
              dataKey={"ID_Agendamento"}
              data={data?.resultset_3 || []}
              enableTotalRows
              hiddenPaginator
              columnsList={[
                {
                  field: "Data_Cancelamento",
                  header: "Data e Horário",
                },
                {
                  field: "Nome_Completo",
                  header: "Cancelado Por",
                },
                {
                  field: "Motivo_Cancelamento",
                  header: "Motivo",
                },
              ]}
            />
          </CardGridCollapseCustom>
        </div>
      </div>

      {data?.resultset_4?.length > 0 && (
        <div className="col-12 mb-3">
          <Alert
            color={alerts[data?.resultset_4[0].Tipo].type}
            className="border-0 m-0"
          >
            <div className="p-2 ps-0 d-flex align-items-center">
              <div className="p-0 pe-3">
                <i
                  className={`fas fa-warning ${alerts[data?.resultset_4[0].Tipo].color} font-size-24`}
                ></i>
              </div>
              <div className="p-0 m-0">
                <p
                  className={`${alerts[data?.resultset_4[0].Tipo].color} font-size-14 p-0 m-0`}
                >
                  {data?.resultset_4[0].Descricao}
                </p>
              </div>
            </div>
          </Alert>
        </div>
      )}

      <div className="col-12 d-flex justify-content-end mb-3">
        <button
          className="btn btn-primary-dark text-white font-size-16 fw-semibold"
          onClick={handleCloseModal}
        >
          Concluído
        </button>
      </div>
    </div>
  );
}

export default GridBody;
